import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { Container } from "../components/globalStyles"

const BlogPostTemplate = ({ data, pageContext, location }) => {
  const post = data.markdownRemark

  const { name } = data.site.siteMetadata.author
  // const { previous, next } = pageContext

  const siteUrl = data.site.siteMetadata.siteUrl
  let socialSharingImageSource
  if (post.frontmatter.previewImage !== null) {
    socialSharingImageSource = `${siteUrl}/${post.frontmatter.previewImage.childImageSharp.fluid.src}`
  }

  // const postUrl = post.frontmatter.path
  // const contentType = post.frontmatter.contentType

  // const previewImagePath = `${siteUrl}/${contentType}/${postUrl}/seo.jpg`

  return (
    <Layout
      location={location}
      name={name}
      date={post.frontmatter.date}
      articleTitle={post.frontmatter.title}
      articleImage={post.frontmatter.previewImage}
    >
      <SEO
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
        image={socialSharingImageSource ? socialSharingImageSource : null}
      />
      <Container>
        <PostContent>
          <section dangerouslySetInnerHTML={{ __html: post.html }} />
        </PostContent>
      </Container>

      {/* <nav>
        <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: 0,
          }}
        >
          <li>
            {previous && (
              <Link to={previous.fields.slug} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={next.fields.slug} rel="next">
                {next.frontmatter.title} →
              </Link>
            )}
          </li>
        </ul>
      </nav> */}
    </Layout>
  )
}

export default BlogPostTemplate

export const PostContent = styled.section`
  max-width: ${props => props.theme.maxWidth};
  margin: 0 auto;

  ul,
  ol {
    padding-left: 1em;
    margin-bottom: 1em;
  }

  img {
    margin-bottom: 1em;
    display: block;
  }
  ul ul,
  ol ol {
    margin-bottom: 0;
  }
  li {
    margin-bottom: 1em;
  }
`

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        siteUrl
        author {
          name
          title
        }
        title
        description
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        contentType
        path
        previewImage {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
